import { Component, Input } from '@angular/core';
import {IncidentInfo} from '../services/traffic-layer.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DatePipe, NgIf } from '@angular/common';

@Component({
  selector: 'app-incident-info-window-content',
  templateUrl: './incident-info-window-content.component.html',
  styleUrls: ['./incident-info-window-content.component.scss'],
  imports: [MatProgressSpinner, NgIf, DatePipe],
})
export class IncidentInfoWindowContentComponent {
  @Input() incidentInfo: IncidentInfo;
}
